module.exports = __webpack_public_path__ + "static/media/locationIcon.9f46df7f.svg";